const Unit001       = () => System.import('./components/units/Unit001.vue');
const Unit002       = () => System.import('./components/units/Unit002.vue');
const Unit003       = () => System.import('./components/units/Unit003.vue');
const Unit004       = () => System.import('./components/units/Unit004.vue');
const Unit005       = () => System.import('./components/units/Unit005.vue');
const Unit006       = () => System.import('./components/units/Unit006.vue');
const Unit007       = () => System.import('./components/units/Unit007.vue');
const Unit008       = () => System.import('./components/units/Unit008.vue');
const Unit009       = () => System.import('./components/units/Unit009.vue');
const Unit010       = () => System.import('./components/units/Unit010.vue');
const Unit011       = () => System.import('./components/units/Unit011.vue');
const Unit012       = () => System.import('./components/units/Unit012.vue');
const Unit013       = () => System.import('./components/units/Unit013.vue');
const Unit014       = () => System.import('./components/units/Unit014.vue');
const Unit016       = () => System.import('./components/units/Unit016.vue');
const Unit017       = () => System.import('./components/units/Unit017.vue');
const Unit018       = () => System.import('./components/units/Unit018.vue');
const Unit019       = () => System.import('./components/units/Unit019.vue');
const Unit020       = () => System.import('./components/units/Unit020.vue');
const Unit021       = () => System.import('./components/units/Unit021.vue');
const Unit022       = () => System.import('./components/units/Unit022.vue');
const Unit023       = () => System.import('./components/units/Unit023.vue');
const Unit024       = () => System.import('./components/units/Unit024.vue');
const Unit025       = () => System.import('./components/units/Unit025.vue');
const Unit026       = () => System.import('./components/units/Unit026.vue');
const Unit027       = () => System.import('./components/units/Unit027.vue');
const Unit028       = () => System.import('./components/units/Unit028.vue');
const Unit029       = () => System.import('./components/units/Unit029.vue');
const Unit030       = () => System.import('./components/units/Unit030.vue');
const Unit031       = () => System.import('./components/units/Unit031.vue');
const Unit032       = () => System.import('./components/units/Unit032.vue');
const Unit033       = () => System.import('./components/units/Unit033.vue');
const Unit034       = () => System.import('./components/units/Unit034.vue');
const Unit035       = () => System.import('./components/units/Unit035.vue');
const Unit036       = () => System.import('./components/units/Unit036.vue');
const Unit037       = () => System.import('./components/units/Unit037.vue');
const Unit038       = () => System.import('./components/units/Unit038.vue');
const Unit039       = () => System.import('./components/units/Unit039.vue');
const Unit040       = () => System.import('./components/units/Unit040.vue');
const Unit041       = () => System.import('./components/units/Unit041.vue');
const Unit042       = () => System.import('./components/units/Unit042.vue');
const Unit044       = () => System.import('./components/units/Unit044.vue');
const Unit045       = () => System.import('./components/units/Unit045.vue');
const Unit046       = () => System.import('./components/units/Unit046.vue');
const Unit047       = () => System.import('./components/units/Unit047.vue');
const Unit048       = () => System.import('./components/units/Unit048.vue');
const Unit049       = () => System.import('./components/units/Unit049.vue');
const Unit050       = () => System.import('./components/units/Unit050.vue');
const Unit051       = () => System.import('./components/units/Unit051.vue');
const Unit052       = () => System.import('./components/units/Unit052.vue');
const Unit053       = () => System.import('./components/units/Unit053.vue');
const Unit054       = () => System.import('./components/units/Unit054.vue');
const Unit055       = () => System.import('./components/units/Unit055.vue');
const Unit056       = () => System.import('./components/units/Unit056.vue');
const Unit057       = () => System.import('./components/units/Unit057.vue');
const Unit999      = () => System.import('./components/units/Unit999.vue');
const HomeBasico    = () => System.import('./components/home/HomeBasico.vue');
const HomeEcommerce = () => System.import('./components/home/HomeEcommerce.vue');
const HomeDashboard = () => System.import('./components/home/HomeDashboard.vue');
const HomeVazio     = () => System.import('./components/home/HomeVazio.vue');

// import Home from './components/home/Home.vue';
// Soh para commit

export const routes = [
    { path: '/homeB', name: 'homeB', component: HomeBasico},
    { path: '/homeE', name: 'homeE', component: HomeEcommerce},
    { path: '/homeD', name: 'homeD', component: HomeDashboard},
    { path: '/unit001', name: 'unit001', component: Unit001},
    { path: '/unit002', name: 'unit002', component: Unit002}, 
    { path: '/unit003', name: 'unit003', component: Unit003},
    { path: '/unit004', name: 'unit004', component: Unit004},
    { path: '/unit005', name: 'unit005', component: Unit005},
    { path: '/unit006', name: 'unit006', component: Unit006, params: true},
    { path: '/unit007', name: 'unit007', component: Unit007},
    { path: '/unit008', name: 'unit008', component: Unit008},
    { path: '/unit009', name: 'unit009', component: Unit009},
    { path: '/unit010', name: 'unit010', component: Unit010},
    { path: '/unit011', name: 'unit011', component: Unit011},
    { path: '/unit012', name: 'unit012', component: Unit012},
    { path: '/unit013', name: 'unit013', component: Unit013},
    { path: '/unit014', name: 'unit014', component: Unit014},
    { path: '/unit016', name: 'unit016', component: Unit016},
    { path: '/unit017', name: 'unit017', component: Unit017},
    { path: '/unit018', name: 'unit018', component: Unit018},
    { path: '/unit019', name: 'unit019', component: Unit019},
    { path: '/unit020', name: 'unit020', component: Unit020},
    { path: '/unit021', name: 'unit021', component: Unit021},
    { path: '/unit022', name: 'unit022', component: Unit022},
    { path: '/unit023', name: 'unit023', component: Unit023},
    { path: '/unit024', name: 'unit024', component: Unit024, params: true},
    { path: '/unit025', name: 'unit025', component: Unit025},
    { path: '/unit026', name: 'unit026', component: Unit026},
    { path: '/unit027', name: 'unit027', component: Unit027},
    { path: '/unit028', name: 'unit028', component: Unit028},
    { path: '/unit029', name: 'unit029', component: Unit029},
    { path: '/unit030', name: 'unit030', component: Unit030},
    { path: '/unit031', name: 'unit031', component: Unit031},
    { path: '/unit032', name: 'unit032', component: Unit032, params: true},
    { path: '/unit033', name: 'unit033', component: Unit033},
    { path: '/unit034', name: 'unit034', component: Unit034},
    { path: '/unit035', name: 'unit035', component: Unit035},
    { path: '/unit036', name: 'unit036', component: Unit036},
    { path: '/unit037', name: 'unit037', component: Unit037},
    { path: '/unit038', name: 'unit038', component: Unit038},
    { path: '/unit039', name: 'unit039', component: Unit039},
    { path: '/unit040', name: 'unit040', component: Unit040},
    { path: '/unit041', name: 'unit041', component: Unit041},
    { path: '/unit042', name: 'unit042', component: Unit042},
    { path: '/unit044', name: 'unit044', component: Unit044},
    { path: '/unit045', name: 'unit045', component: Unit045},
    { path: '/unit046', name: 'unit046', component: Unit046},
    { path: '/unit047', name: 'unit047', component: Unit047},
    { path: '/unit048', name: 'unit048', component: Unit048},
    { path: '/unit049', name: 'unit049', component: Unit049},
    { path: '/unit050', name: 'unit050', component: Unit050},
    { path: '/unit051', name: 'unit051', component: Unit051},
    { path: '/unit052', name: 'unit052', component: Unit052},
    { path: '/unit053', name: 'unit053', component: Unit053},
    { path: '/unit054', name: 'unit054', component: Unit054},
    { path: '/unit055', name: 'unit055', component: Unit055},
    { path: '/unit056', name: 'unit056', component: Unit056},
    { path: '/unit057', name: 'unit057', component: Unit057},
    { path: '/unit999', name: 'unit999', component: Unit999},
    { path: '*', component: HomeVazio}
];



// WEBPACK FOOTER //
// ./src/routes.js